import React from 'react'
import FormatCurrency from 'components/Common/FormatCurrency'
import Pill from 'components/Luxkit/Pill'
import Heading from 'components/Luxkit/Typography/Heading'
import Group from 'components/utils/Group'
import TextButton from 'components/Luxkit/Button/TextButton'
import PaletteProvider from 'contexts/PaletteProvider'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import { getCruiseOfferPriceVariation } from 'lib/Cruise/calculatingPrices'
import BodyText from 'components/Luxkit/Typography/BodyText'
import LineClockDollarIcon from 'components/Luxkit/Icons/line/LineClockDollarIcon'
import Caption from 'components/Luxkit/Typography/Caption'
import useIsHomepage from 'home/hooks/isHomepage'

interface Props {
  offer: App.CruiseOffer;
  className?: string;
}

function CruisePriceDetails(props: Props) {
  const { offer } = props
  const { mainDepartureDetails } = offer
  const { lowestOverallPriceDetails } = mainDepartureDetails
  const { primaryPrice } = getCruiseOfferPriceVariation(offer, lowestOverallPriceDetails)
  const { promotion, discountPills } = lowestOverallPriceDetails
  const promotionDetails = promotion ?? offer.fallbackPromotion
  const isHomepage = useIsHomepage()

  return (
    <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="end">
      <Group direction="vertical">
        <PaletteProvider type="default">
          <Group direction="vertical" gap={4}>
            {(!offer.disableDeposits && !isHomepage) && (
              <div>
                <BodyText variant="small">
                  {promotionDetails?.deposit && <Pill kind="tertiary" variant="primary" startIcon={<LineClockDollarIcon />}>
                    Secure with a {promotionDetails.deposit.formattedValue} deposit
                  </Pill>}
                  {!promotionDetails?.deposit && <Pill kind="tertiary" variant="primary" startIcon={<LineClockDollarIcon />}>
                    Deposits available
                  </Pill>}
                </BodyText>
              </div>
            )}
            {discountPills?.discountPercentage && discountPills?.price && (
              <Group direction="horizontal" gap={4} verticalAlign="center">
                <Caption variant="medium" weight="bold" colour="neutral-one">
                  Valued up to <FormatCurrency value={discountPills.price} />
                </Caption>
                <Pill
                  kind="primary"
                  variant="success">
                  -{discountPills.discountPercentage}%</Pill>
              </Group>
            )}
          </Group>
        </PaletteProvider>
        <Caption variant="large" colour="neutral-two">
          From
        </Caption>
        <Group direction="horizontal" verticalAlign="center" gap={2}>
          <Heading variant="heading4">
            <FormatCurrency currency={primaryPrice.currencyCode} value={primaryPrice.total ?? 0} />
          </Heading>
          <Caption variant="large" colour="neutral-two">
            /{primaryPrice.type}
          </Caption>
        </Group>
        <Caption variant="large" colour="neutral-three">Includes taxes & fees</Caption>
        <Caption variant="large" colour="neutral-three">Inside cabin</Caption>
      </Group>
      <CSSBreakpoint min="md">
        <TextButton kind="primary" nonInteractable>
          View
        </TextButton>
      </CSSBreakpoint>
    </Group>
  )
}

export default CruisePriceDetails
